import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import userSessionReducer from './reducers/authentication/authentication-reducer';
import uiTriggerState from './reducers/ui-trigger/ui-trigger-state';
import userDataReducer from './reducers/user-data/user-data-reducer';
import bankValidationsReducer from './reducers/bank-validations-reducer/bank-validations-reducer';
import dashboardReducer from './reducers/dashboard/dashboard-reducer';
import documentDataReducer from './reducers/document-data-reducer/document-data-reducer';
import referralReducer from './reducers/referral/referral-reducer';
import messageReducer from './reducers/message/message-reducer';
import userFlowReducer from './reducers/user-flow/user-flow-reducer';
import userStatusReducer from './reducers/user-status/user-status-reducer';
import mobileValidationReducer from './reducers/mobile-validation/mobile-validation-reducer';
import transactionReducer from './reducers/transaction/transaction-reducer';
import scheduleInterviewReducer from './reducers/schedule-interview/schedule-interview-reducer';
import newUserFlowReducer from './reducers/new-user-flow/user-flow-reducer';
import niumForexReducer from './reducers/nium-forex-flow/nium-forex-reducer';
import helpCenterReducer from './reducers/help-center-reducer/help-center-reducer';
import flagsmithReducer from './reducers/flagsmith-reducer/flagsmith-reducer.ts';
import rfiReducer from './reducers/rfi/rfi-reducer';
import newBeneficiaryReducer from './reducers/new-bene-flow/new-bene-flow-reducer';
import shimmerReducer from './reducers/shimmer/shimmer-reducer';

export default combineReducers({
  rootReducer: combineReducers({
    userSessionReducer,
    uiTriggerState,
    userDataReducer,
    bankValidationsReducer,
    dashboardReducer,
    referralReducer,
    messageReducer,
    documentDataReducer,
    userFlowReducer,
    userStatusReducer,
    mobileValidationReducer,
    transactionReducer,
    scheduleInterviewReducer,
    newUserFlowReducer,
    niumForexReducer,
    helpCenterReducer,
    flagsmithReducer,
    rfiReducer,
    newBeneficiaryReducer,
    shimmerReducer
  }),
  form
});
